<div class="custom-input-container">
  @if (label) {
  <label [for]="id" class="input-label">{{ label }}</label>
  }
  <input #inputElement [id]="id" [type]="type" [placeholder]="placeholder" (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (blur)="onTouched()" [disabled]="disabled" [readonly]="readonly" class="custom-input-field"
    [class.ng-invalid]="isInvalid" [class.ng-dirty]="control?.dirty" [attr.step]="step" />
  @if (isInvalid) {
  <small class="error-text">{{ errorMessage }}</small>
  }
</div>